import { webmasterConstants } from '../../constants/webmaster';
import { startSetUnreadTicketsCount } from '../../actions/webmaster';

export const setUnreadTickets = store => next => action => {
  if (action.type === webmasterConstants.SET_DYNAMIC_DATA) {
    store.dispatch(startSetUnreadTicketsCount());

    const unread = setInterval(() => {
      const state = store.getState();

      if (state.webmaster && state.webmaster.isAuthenticated) {
        store.dispatch(startSetUnreadTicketsCount());
      } else {
        clearInterval(unread);
      }
    }, 120 * 1000);
  }

  return next(action);
};
